import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import App from './App.vue';
import router from './router';
import store from './store';

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

// Иконки
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faEnvelope, faTimes, faCheckCircle, faComment,
  faChartLine, faTachometerAlt, faDollarSign,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

// Глобальные иконки
library.add(faEnvelope);
library.add(faTimes);
library.add(faCheckCircle);
library.add(faComment);
library.add(faChartLine);
library.add(faTachometerAlt);
library.add(faDollarSign);

// Подключить компонент иконок глобально
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

Vue.use(BootstrapVue);

Vue.component('vue-phone-number-input', VuePhoneNumberInput);


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
